// extracted by mini-css-extract-plugin
module.exports = {"container":"section-module--container--1UZoD","innerContainer":"section-module--innerContainer--X6glP"};